import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { createScholarshipType, updateScholarshipType } from "../../services/school/scholarshipTypetype";
import { ScholarshipTypeType } from "../../types/ScholarshipType";
import { yupResolver } from "@hookform/resolvers/yup";
import { ScholarshipTypeformValidation } from "./ScholarshipTypeformValidation";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { resetScholarshipTypeData } from "../../redux/slices/school/scholarshipType";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
export const UpdateScholarshipType = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: updateScholarshipType, mutationKey: "updateScholarshipType" });
  const data = useAppSelector((state) => state.scholarshipType);
    const dispatch = useAppDispatch();

    const { control, handleSubmit, formState: { errors } } = useForm<ScholarshipTypeType>(
        {
            resolver: yupResolver(ScholarshipTypeformValidation),
            defaultValues:data,
            mode: 'onBlur',
            reValidateMode: 'onBlur',
            shouldUseNativeValidation: false,
          }
);

    const onSubmit = handleSubmit(async (data) => {
        try {
            const result = await mutation.mutateAsync(data);
            if (result) {
                toast.success("Tipo de Bolsa criado!");
                navigate(routes.scholarshipTypes);
            }
        } catch (err: any) {
            toast.error(`${mutation.error ?? err?.message}`);
        }
    });
    const handleBack = () => {
        dispatch(resetScholarshipTypeData());
        navigate(routes.scholarshipTypes);
      }
    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent name="description" label="Nome" control={control} errors={errors} required={true} />
                 <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
                              <ChevronLeftIcon /> Voltar
                            </Button>
                            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
                              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                              Registar
                            </Button>
                          </Flex>
                </Flex>
            </Card>
        </form>
    );
};
